import { render, staticRenderFns } from "./authTaobao.vue?vue&type=template&id=3e8a3538&scoped=true&"
import script from "./authTaobao.vue?vue&type=script&lang=js&"
export * from "./authTaobao.vue?vue&type=script&lang=js&"
import style0 from "./authTaobao.vue?vue&type=style&index=0&id=3e8a3538&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a3538",
  null
  
)

export default component.exports